import { render, staticRenderFns } from "./EmailContentModal.vue?vue&type=template&id=0b93eb2a&scoped=true&"
import script from "./EmailContentModal.vue?vue&type=script&lang=js&"
export * from "./EmailContentModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailContentModal.vue?vue&type=style&index=0&id=0b93eb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b93eb2a",
  null
  
)

export default component.exports